// DataTab — extraído de pages/clients/[id].tsx pra Story 2.6.
// Story 10.9 — agrupa card "Dados fiscais" (override CNPJ DR-036) no final.
import { formatDocument } from '@control-center/shared';

import type { ClientEntity } from '../../../lib/clients-api';
import { FiscalDataCard } from '../FiscalDataCard';
import { SuspensionOptOutCard } from '../SuspensionOptOutCard';

type Field = {
  label: string;
  value: string | null | undefined;
  tabular?: boolean;
  mono?: boolean;
};

export function DataTab({ client }: { client: ClientEntity }): JSX.Element {
  const sections: { title: string; fields: Field[] }[] = [
    {
      title: 'Identificação',
      fields: [
        {
          label: 'Tipo',
          value: client.type === 'pessoa_fisica' ? 'Pessoa física' : 'Pessoa jurídica',
        },
        { label: 'Nome fantasia', value: client.trade_name },
        {
          label: 'Documento',
          value: client.document ? formatDocument(client.document) : null,
          tabular: true,
        },
        { label: 'Tipo de documento', value: client.document_type },
        { label: 'IE', value: client.inscricao_estadual, tabular: true },
        { label: 'IM', value: client.inscricao_municipal, tabular: true },
      ],
    },
    {
      title: 'Contato',
      fields: [
        { label: 'E-mail principal', value: client.email },
        { label: 'E-mail fiscal', value: client.fiscal_email },
        { label: 'E-mail financeiro', value: client.financial_email },
        { label: 'Telefone', value: client.phone, tabular: true },
        { label: 'WhatsApp', value: client.whatsapp, tabular: true },
        { label: 'WhatsApp financeiro', value: client.financial_whatsapp, tabular: true },
        { label: 'Canal preferido', value: client.preferred_channel },
      ],
    },
    {
      title: 'Endereço',
      fields: [
        {
          label: 'Logradouro',
          value: [client.address_street, client.address_number].filter(Boolean).join(', ') || null,
        },
        { label: 'Complemento', value: client.address_complement },
        { label: 'Bairro', value: client.address_neighborhood },
        {
          label: 'Cidade / UF',
          value: [client.address_city, client.address_state].filter(Boolean).join(' / ') || null,
        },
        { label: 'CEP', value: client.address_zip_code, tabular: true },
        { label: 'País', value: client.address_country },
      ],
    },
    {
      title: 'Operacional',
      fields: [
        { label: 'Responsável', value: client.responsavel },
        { label: 'Observações', value: client.observations },
        { label: 'Isento de ISS', value: client.is_iss_exempt ? 'Sim' : 'Não' },
        { label: 'Sem régua de cobrança', value: client.skip_dunning ? 'Sim' : 'Não' },
      ],
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {sections.map((section) => (
        <div key={section.title}>
          <h3 className="mb-3 text-[12px] font-semibold uppercase tracking-wider text-muted-3">
            {section.title}
          </h3>
          <dl className="grid grid-cols-1 gap-x-6 gap-y-3 md:grid-cols-2">
            {section.fields.map((f) => (
              <div
                key={f.label}
                className="flex flex-col gap-[2px] border-b border-line/60 pb-2 last:border-b-0"
              >
                <dt className="text-[11px] uppercase tracking-wider text-muted-3">{f.label}</dt>
                <dd
                  className={`text-[13px] ${f.value ? 'text-ink-2' : 'text-muted-3'} ${
                    f.tabular ? 'tnum' : ''
                  } ${f.mono ? 'font-mono text-[12px]' : ''}`}
                >
                  {f.value || '—'}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      ))}

      <FiscalDataCard client={client} />

      <SuspensionOptOutCard client={client} />
    </div>
  );
}
